export default __webpack_public_path__ + "static/media/folder-open-icon.347a462c.svg";